import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { defaultInitiativesIdMapState } from './state';

import { InitiativeReference, Task, UpdateInitiativeReferenceRequest } from '@types';
import { rebuildArray, RebuildArrayOptions } from '@lib';

const empty: InitiativeReference = {
	ownerIds: [],
	scopeCounts: {},
	stakeholders: [],
	tagIds: [],
	tasks: []
};

const taskArrayUpdateOptions: RebuildArrayOptions<Task> = {
	afterReorder: (task, index) => ({
		...task,
		orderIndex: index
	}),
	idSelector: (task) => task.initiativeTaskId
};

function rebuildReferenceEntry(
	entry: UpdateInitiativeReferenceRequest,
	existingEntry: InitiativeReference
): InitiativeReference {
	return {
		...existingEntry,
		ownerIds: rebuildArray(existingEntry.ownerIds, entry.ownerIds),
		scopeCounts: entry.scopeCounts ? { ...entry.scopeCounts } : { ...existingEntry.scopeCounts },
		stakeholders: rebuildArray(existingEntry.stakeholders, entry.stakeholders),
		tagIds: rebuildArray(existingEntry.tagIds, entry.tagIds),
		tasks: rebuildArray(existingEntry.tasks, entry.tasks, taskArrayUpdateOptions)
	};
}

export const coreInitiativesIdMapSlice = createUpdateSyncSlice({
	name: 'CoreInitiativesIdMap',
	state: defaultInitiativesIdMapState,
	transform: (action: Array<UpdateInitiativeReferenceRequest>, state = {}) => {
		if (!action.length) {
			return state;
		}

		const updatedState: typeof state = {
			...state
		};

		for (const entry of action) {
			const key = entry.initiativeId;

			updatedState[ key ] = rebuildReferenceEntry(entry, state[ key ] ?? { ...empty });
		}

		return updatedState;
	}
});
